import { createFileRoute } from "@tanstack/react-router";

import QuestDetailsForm from "@/components/QuestProfile/QuestDetailsForm";

const Component = () => {
  const { questUuid } = Route.useParams();
  return <QuestDetailsForm questUuid={questUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/profile/details")({
  component: Component,
});
